module.exports = __webpack_public_path__ + "static/media/projectedLossChevrron.9dd639d1.svg";